<template>
  <div>
    <app-header :title="getLabel('FILM_CODE_INSPECTOR')" />

    <b-container>
      <b-row>
        <b-col>
          <b-form inline @submit.stop.prevent="lookup()">
            <label class="mr-2" v-label-key="'FILM_CODE'">Film Code</label>
            <b-input v-model="codeId" type="text" class="form-control" />
            <b-button variant="light" type="submit" class="ml-2">
              <span v-label-key="'GO'">Go</span>
            </b-button>
          </b-form>
          <b-table-simple v-if="code" striped class="mt-5">
            <b-tr>
              <b-td><span v-label-key="'CODE'">Code</span></b-td>
              <b-td>{{ code.code }}</b-td>
            </b-tr>

            <b-tr>
              <b-td><span v-label-key="'CREATED'">Created</span></b-td>
              <b-td>{{ code.created | moment('YYYY-MM-DD') }}</b-td>
            </b-tr>

            <b-tr>
              <b-td><span v-label-key="'UPDATED'">Updated</span></b-td>
              <b-td>{{ code.updated | moment('YYYY-MM-DD') }}</b-td>
            </b-tr>

            <b-tr>
              <b-td><span v-label-key="'FILM_TYPE'">Film Type</span></b-td>
              <b-td
                >{{ code.filmtype_name }} {{ code.filmtype_description }}</b-td
              >
            </b-tr>

            <b-tr>
              <b-td
                ><span v-label-key="'PRINT_STATUS'">Print Status</span></b-td
              >
              <b-td>{{
                code.printed
                  ? getLabel('USED') || 'Used'
                  : getLabel('NOT_USED') || 'Not Used'
              }}</b-td>
            </b-tr>

            <b-tr>
              <b-td><span v-label-key="'CUT_STATUS'">Cut Status</span></b-td>
              <b-td>{{
                code.cut
                  ? getLabel('USED') || 'Used'
                  : getLabel('NOT_USED') || 'Not Used'
              }}</b-td>
            </b-tr>

            <b-tr v-if="code.transaction_id">
              <b-td><span v-label-key="'TEMPLATE'">Template</span></b-td>
              <b-td>
                {{ code.manufacturer_name }} / {{ code.device_name }} /
                {{ code.template_name }}
              </b-td>
            </b-tr>

            <b-tr v-if="code.transaction_id">
              <b-td><span v-label-key="'STORE'">Store</span></b-td>
              <b-td>{{ code.chain_name }} / {{ code.store_name }}</b-td>
            </b-tr>

            <b-tr v-if="code.transaction_id">
              <b-td
                ><span v-label-key="'CUT_MACHINE'">Cutting Machine</span></b-td
              >
              <b-td
                >{{ code.machine_name }} / {{ code.machine_connection }}</b-td
              >
            </b-tr>

            <b-tr v-if="code.transaction_id">
              <b-td><span v-label-key="'STATUS'">Status</span></b-td>
              <b-td>{{ code.status }}</b-td>
            </b-tr>

            <b-tr v-if="code.failure_reason">
              <b-td
                ><span v-label-key="'FAILURE_REASON'"
                  >Failure Reason</span
                ></b-td
              >
              <b-td
                >{{ code.failure_reason }} -
                {{ failureReasonName(code.failure_reason) }}</b-td
              >
            </b-tr>
            <b-tr v-if="code.failure_photo">
              <b-td
                ><span v-label-key="'FAILURE_REASON_PHOTO'"
                  >Failure Photo</span
                ></b-td
              >
              <b-td>
                <img
                  :src="'https://cdn.gokaizen.com/' + code.failure_photo"
                  alt=""
                />
              </b-td>
            </b-tr>
          </b-table-simple>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import { mapGetters } from 'vuex';

const failureReasonMap = {
  100: 'FAILURE_REASON_OTHER_PRINT_ERROR',
  101: 'FAILURE_REASON_INSUFFICIENT_INK',
  102: 'FAILURE_REASON_CANNOT_CONNECT_PRINTER',
  103: 'FAILURE_REASON_NO_PAPER',
  104: 'FAILURE_REASON_PRINTED_WRONG_SIZE',
  105: 'FAILURE_REASON_PRINTED_HALF',
  106: 'FAILURE_REASON_PRINTED_OFF_FILM',
  200: 'FAILURE_REASON_OTHER_CUT_ERROR',
  201: 'FAILURE_REASON_CANNOT_CONNECT',
  202: 'FAILURE_REASON_CUTTING_STOPPED_PART_WAY',
  203: 'FAILURE_REASON_NOT_CUT_THROUGH',
  204: 'FAILURE_REASON_CUT_WRONG_PLACE',
  205: 'FAILURE_REASON_CUT_WRONG_SIZE',
};

export default {
  components: {
    AppHeader,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
    failureReasonName() {
      return failureCode => {
        if (failureCode) {
          return this.getLabel(failureReasonMap[failureCode]);
        }
        return '';
      };
    },
  },
  data() {
    return {
      codeId: null,
      code: null,
    };
  },
  methods: {
    lookup() {
      $api.get(`/v1/dashboard/filmcodes/${this.codeId}`).then(code => {
        if (!code) {
          alert('Invalid code'); // eslint-disable-line no-alert
        }
        this.code = code;
      });
    },
  },
};
</script>
